export const brandPermission = {
    brandView: "brand.view",
    brandCreate: "brand.create",
    brandDelete: "brand.delete",
    brandUpdate: "brand.update"
};
